// Criterio ÚNICO de "esta plantilla lleva un archivo en el encabezado" (feat_308).
// Lo consumen los 3 puntos de UI de plantillas Meta: el form de creación y el de
// envío del MetaTemplatesDrawer, y el InlineTemplateSender del chat.
//
// Espeja el backend (MetaTemplateService.MEDIA_HEADER_FORMATS / headerKindForTemplate):
// el tipo del adjunto lo manda la PLANTILLA (headerType), NUNCA el mime del archivo.

export const MEDIA_HEADER_TYPES = ["IMAGE", "DOCUMENT", "VIDEO"];

// Formatos elegibles al CREAR una plantilla ("NONE" = sin encabezado).
export const HEADER_FORMATS = ["NONE", "TEXT", "IMAGE", "DOCUMENT", "VIDEO"];

export const isMediaHeaderType = (headerType) =>
  MEDIA_HEADER_TYPES.includes(String(headerType || "").toUpperCase());

// `accept` del <input type=file> por formato de encabezado. Documento acepta los
// tipos ofimáticos habituales (Meta admite más, pero es el caso real: facturas y
// presupuestos); imagen y video se acotan por familia de mime.
export const acceptForHeaderType = (headerType) => {
  switch (String(headerType || "").toUpperCase()) {
    case "IMAGE":
      return "image/*";
    case "VIDEO":
      return "video/*";
    case "DOCUMENT":
      return ".pdf,.doc,.docx,.xls,.xlsx,application/pdf";
    default:
      return undefined;
  }
};
